import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

export interface ToucanWebsiteState {
  jwt: string | null;
  jwtRefresh: string | null;
  userEmail: string | null;
}

const vuexLocal = new VuexPersistence<ToucanWebsiteState>({
  storage: window.localStorage,
});

const store: StoreOptions<ToucanWebsiteState> = {
  state: {
    jwt: null,
    jwtRefresh: null,
    userEmail: "",
  },
  mutations: {
    // Save current JWT
    jwt(state, jwt) {
      state.jwt = jwt;
    },
    // Save current refresh JWT
    jwtRefresh(state, jwtRefresh) {
      state.jwtRefresh = jwtRefresh;
    },
    // Save logged user
    userEmail(state, email) {
      state.userEmail = email;
    },
  },
  actions: {
    // Set current JWT
    saveJWT({ commit }, jwt) {
      commit("jwt", jwt);
    },
    // Set current JWT Refresh
    saveJWTRefresh({ commit }, jwtRefresh) {
      commit("jwtRefresh", jwtRefresh);
    },
    // Set logged user
    saveUserEmail: ({ commit }, email) => {
      // user is active
      commit("userEmail", email);
    },
    // Loggout user
    logout({ commit }, type) {
      // User state
      commit("userEmail", null);
      // JWT is deleted
      commit("jwt", null);
      // JWT Refresh is deleted
      commit("jwtRefresh", type);
    },
  },
  plugins: [vuexLocal.plugin],
  getters: {
    getJwt: (state) => {
      return state.jwt;
    },
    getJwtRefresh: (state) => {
      return state.jwtRefresh;
    },
    getUserEmail: (state) => {
      return state.userEmail;
    },
  },
  modules: {},
};

export default new Vuex.Store<ToucanWebsiteState>(store);
